<template>
  <div class="meeting-subscription-view">
    <h1 class="welcome-text">Hallo und danke</h1>
  </div>
</template>
<script>
import { runFlowByID } from '../services/axios/flow-runner.api';

export default {
  name: 'MeetingSubscriptionPage',
  data() {
    return {};
  },
  methods: {
    async call_meeting_workflow() {
      try {
        const params = `?id=${1728642802691}`;
        const payload = {
          eventtypeuuid: this.$route?.query?.event_type_uuid,
        };
        const headers = {
          Accept: 'application/json',
        };
        await runFlowByID(null, params, payload, { headers });
      } catch (err) {}
    },
  },
  created() {
    if (this.$route?.query?.event_type_uuid) {
      this.call_meeting_workflow();
    }
  },
};
</script>
<style scoped>
*,
::before,
::after {
  box-sizing: border-box !important;
}
.meeting-subscription-view {
  height: 100%;
  width: 100%;
}
.meeting-subscription-view .welcome-text {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
</style>
